(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plugx-liquidacion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pxLazyVideoInit) return;
    window.__pxLazyVideoInit = true;

    var videos = document.querySelectorAll('[data-lazy-video]');
    if (!videos.length) return;

    function start(video) {
      var src = video.dataset.src || video.dataset.srcMobile || video.dataset.srcDesktop;
      if (!src) return;
      video.src = src;
      video.play().catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
    } else {
      var lazyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start(entry.target);
              lazyObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '900px 0px' }
      );
      videos.forEach(function (v) { lazyObserver.observe(v); });
    }
  })();

  (function () {
    var els = document.querySelectorAll('[data-liq-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('plugx-liq--visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('plugx-liq--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    els.forEach(function (el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plugx-nuevo-drop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pxLazyVideoInit) return;
    window.__pxLazyVideoInit = true;

    var videos = document.querySelectorAll('[data-lazy-video]');
    if (!videos.length) return;

    function start(video) {
      var src = video.dataset.src || video.dataset.srcMobile || video.dataset.srcDesktop;
      if (!src) return;
      video.src = src;
      video.play().catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '900px 0px' }
      );
      videos.forEach(function (v) { observer.observe(v); });
    }
  })();

  (function () {
    document.querySelectorAll('[data-pxnd-scroll-cue]').forEach(function (cue) {
      cue.addEventListener('click', function () {
        var wrapper = cue.closest('[id^="shopify-section-"]') || cue.closest('.pxnd-wrap');
        var next = wrapper ? wrapper.nextElementSibling : null;
        if (next) {
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
        }
      });
    });
  })();

  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }

    function fireConfetti() {
      if (typeof confetti === 'undefined') return;
      var c = ['#cc0000', '#ff1a1a', '#ff0055', '#ffffff', '#ff6644'];
      confetti({ particleCount: 60, angle: 60, spread: 65, origin: { x: 0, y: 0.65 }, colors: c, gravity: 1.1, ticks: 200 });
      setTimeout(function () { confetti({ particleCount: 60, angle: 120, spread: 65, origin: { x: 1, y: 0.65 }, colors: c, gravity: 1.1, ticks: 200 }); }, 180);
      setTimeout(function () { confetti({ particleCount: 75, angle: 90, spread: 95, origin: { x: 0.5, y: 0.55 }, colors: c, startVelocity: 28, gravity: 0.9, ticks: 220 }); }, 360);
    }

    function loadConfettiLib(cb) {
      if (typeof confetti !== 'undefined') { cb(); return; }
      if (window.__pxConfettiLoading) {
        window.__pxConfettiQueue = window.__pxConfettiQueue || [];
        window.__pxConfettiQueue.push(cb);
        return;
      }
      window.__pxConfettiLoading = true;
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
      s.onload = function () {
        cb();
        (window.__pxConfettiQueue || []).forEach(function (fn) { fn(); });
        window.__pxConfettiQueue = [];
      };
      document.head.appendChild(s);
    }

    document.querySelectorAll('[data-pxnd-countdown]').forEach(function (el) {
      var target = new Date(el.dataset.target).getTime();
      if (!target || isNaN(target)) return;

      var shouldConfetti = el.dataset.confetti === 'true';
      var grid = el.querySelector('[data-pxnd-countdown-grid]');
      var label = el.querySelector('[data-pxnd-countdown-label]');
      var live = el.querySelector('[data-pxnd-countdown-live]');
      var preLive = el.querySelector('[data-pxnd-pre-live]');
      var postLive = el.querySelector('[data-pxnd-post-live]');
      var dEl = el.querySelector('[data-unit="days"]');
      var hEl = el.querySelector('[data-unit="hours"]');
      var mEl = el.querySelector('[data-unit="minutes"]');
      var sEl = el.querySelector('[data-unit="seconds"]');
      var finished = false;

      function finish() {
        if (finished) return;
        finished = true;
        if (grid) grid.hidden = true;
        if (label) label.hidden = true;
        if (preLive) preLive.hidden = true;
        if (live) live.hidden = false;
        if (postLive) postLive.hidden = false;
        el.classList.add('is-live');
        if (shouldConfetti) {
          loadConfettiLib(fireConfetti);
        }
      }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          finish();
          clearInterval(timer);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(minutes);
        if (sEl) sEl.textContent = pad(seconds);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plugx-referencias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pxLazyVideoInit) return;
    window.__pxLazyVideoInit = true;

    var videos = document.querySelectorAll('[data-lazy-video]');
    if (!videos.length) return;

    function start(video) {
      var src = video.dataset.src || video.dataset.srcMobile || video.dataset.srcDesktop;
      if (!src) return;
      video.src = src;
      video.play().catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
    } else {
      var lazyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start(entry.target);
              lazyObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '900px 0px' }
      );
      videos.forEach(function (v) { lazyObserver.observe(v); });
    }
  })();

  (function () {
    var els = document.querySelectorAll('[data-refs-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('plugx-refs--visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('plugx-refs--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    els.forEach(function (el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prendas-pedido-colecciones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPoaCollNav(nav) {
      if (!nav || nav.dataset.poaCollnavInit) return;
      nav.dataset.poaCollnavInit = 'true';

      var track = nav.querySelector('[data-poa-collnav-track]') || nav.querySelector('.poa-collnav__track');
      var btnL = nav.querySelector('.poa-collnav__arrow--left');
      var btnR = nav.querySelector('.poa-collnav__arrow--right');
      if (!track || !btnL || !btnR) return;

      var step = 160;

      btnL.addEventListener('click', function () {
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });
      btnR.addEventListener('click', function () {
        track.scrollBy({ left: step, behavior: 'smooth' });
      });

      function updateArrows() {
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        btnL.style.opacity = atStart ? '0' : '1';
        btnL.style.pointerEvents = atStart ? 'none' : 'auto';
        btnR.style.opacity = atEnd ? '0' : '1';
        btnR.style.pointerEvents = atEnd ? 'none' : 'auto';
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    function initAll() {
      document.querySelectorAll('.poa-collnav').forEach(initPoaCollNav);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prendas-pedido-home-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pxLazyVideoInit) return;
    window.__pxLazyVideoInit = true;

    var videos = document.querySelectorAll('[data-lazy-video]');
    if (!videos.length) return;

    function start(video) {
      var src = video.dataset.src || video.dataset.srcMobile || video.dataset.srcDesktop;
      if (!src) return;
      video.src = src;
      video.play().catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
    } else {
      var lazyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start(entry.target);
              lazyObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '900px 0px' }
      );
      videos.forEach(function (v) { lazyObserver.observe(v); });
    }
  })();

  (function () {
    var els = document.querySelectorAll('[data-pab-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pab--visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pab--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    els.forEach(function (el) { observer.observe(el); });

    document.querySelectorAll('[data-pab-scroll-cue]').forEach(function (cue) {
      cue.addEventListener('click', function () {
        var wrapper = cue.closest('[id^="shopify-section-"]') || cue.closest('.pab');
        var next = wrapper ? wrapper.nextElementSibling : null;
        if (next) {
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prendas-pedido-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPoaModal(root) {
      if (!root || root.dataset.poaModalInit) return;
      root.dataset.poaModalInit = 'true';

      var backdrop = root.querySelector('[data-poa-modal-backdrop]');
      var closeBtn = root.querySelector('[data-poa-modal-close]');
      var backBtn = root.querySelector('[data-poa-modal-back]');
      var nextBtn = root.querySelector('[data-poa-modal-next]');
      var pages = Array.prototype.slice.call(root.querySelectorAll('[data-poa-page]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-poa-dot]'));
      var totalPages = pages.length;
      var current = 1;
      var lastFocused = null;

      function renderPage() {
        pages.forEach(function (page) {
          var pageNum = parseInt(page.getAttribute('data-poa-page'), 10);
          var isActive = pageNum === current;
          page.classList.toggle('is-active', isActive);
          page.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        dots.forEach(function (dot) {
          var dotNum = parseInt(dot.getAttribute('data-poa-dot'), 10);
          dot.classList.toggle('is-active', dotNum === current);
        });
        backBtn.disabled = current === 1;
        if (current === totalPages) {
          nextBtn.textContent = 'EXPLORAR PRENDAS';
        } else {
          nextBtn.textContent = 'SIGUIENTE';
        }
      }

      function openModal() {
        lastFocused = document.activeElement;
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', onKeyDown);
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKeyDown);
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }

      function onKeyDown(event) {
        if (event.key === 'Escape') {
          closeModal();
          return;
        }
        if (event.key === 'Tab') {
          var focusable = root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (backdrop) backdrop.addEventListener('click', closeModal);

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (current > 1) {
            current -= 1;
            renderPage();
          }
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (current < totalPages) {
            current += 1;
            renderPage();
          } else {
            closeModal();
          }
        });
      }

      renderPage();
      openModal();
    }

    function initAll() {
      var modals = document.querySelectorAll('[data-poa-modal]');
      modals.forEach(function (el) {
        initPoaModal(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prendas-pedido-producto"]) return;
  try {
    
  (function () {
    function initPoaPdp(root) {
      if (!root || root.dataset.poaPdpInit) return;
      root.dataset.poaPdpInit = 'true';

      var sectionId = root.getAttribute('data-section-id');
      var dataScript = document.querySelector('[data-poa-pdp-variants][data-section-id="' + sectionId + '"]');
      var variants = [];
      try {
        variants = dataScript ? JSON.parse(dataScript.textContent) : [];
      } catch (e) {
        variants = [];
      }

      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-poa-pdp-option-select]'));
      var priceEl = root.querySelector('[data-poa-pdp-price]');
      var priceElLow = root.querySelector('[data-poa-pdp-price-low]');
      var priceElHigh = root.querySelector('[data-poa-pdp-price-high]');
      var cta = root.querySelector('[data-poa-pdp-cta]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-poa-pdp-thumb]'));
      var mainImg = root.querySelector('[data-poa-pdp-main-img]');

      function currencyFormat(el, cents) {
        if (!el) return '';
        // Reutiliza el formato que Shopify ya renderizó en el precio inicial,
        // sustituyendo solo la parte numérica para no perder el símbolo/local del shop.
        var template = el.getAttribute('data-template');
        if (!template) {
          template = el.textContent.replace(/[\d.,]+/, '__AMOUNT__');
          el.setAttribute('data-template', template);
        }
        var amount = (cents / 100).toFixed(2);
        return template.replace('__AMOUNT__', amount);
      }

      function findMatchingVariant() {
        if (!selects.length) return variants[0];
        var selected = selects.map(function (s) { return s.value; });
        return variants.find(function (variant) {
          var options = [variant.option1, variant.option2, variant.option3].filter(function (o) { return o !== null && o !== undefined; });
          return selected.every(function (val, i) { return options[i] === val; });
        });
      }

      function updateForVariant() {
        var variant = findMatchingVariant();
        if (!variant) return;
        if (priceEl) priceEl.textContent = currencyFormat(priceEl, variant.price);
        if (priceElLow) priceElLow.textContent = currencyFormat(priceElLow, Math.max(0, variant.price - 4000));
        if (priceElHigh) priceElHigh.textContent = currencyFormat(priceElHigh, variant.price + 4000);
        if (cta) cta.dataset.selectedVariantId = variant.id;
        updateCtaLink(variant);
      }

      function updateCtaLink(variant) {
        if (!cta || !cta.hasAttribute('data-whatsapp-number')) return;
        var number = cta.getAttribute('data-whatsapp-number').replace(/\D/g, '');
        var title = cta.getAttribute('data-product-title') || '';
        var url = cta.getAttribute('data-product-url') || '';
        var talla = selects.length ? selects.map(function (s) { return s.value; }).join(' / ') : '';
        var price = priceEl ? priceEl.textContent.trim() : '';

        var lines = ['Hola, deseo cotizar esta prenda. Ahora te indico mi talla:', title];
        if (talla) lines.push('Talla/opción: ' + talla);
        if (price) lines.push('Precio referencial: ' + price);
        if (url) lines.push(window.location.origin + url);

        var message = encodeURIComponent(lines.join('\n'));
        cta.setAttribute('href', 'https://wa.me/' + number + '?text=' + message);
      }

      selects.forEach(function (select) {
        select.addEventListener('change', updateForVariant);
      });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImg) {
            // El <img> principal trae "srcset" para verse nítido en distintas pantallas.
            // Si solo cambiamos "src", el navegador puede seguir usando el srcset viejo
            // y la imagen nunca cambia visualmente. Quitamos srcset/sizes para forzar
            // que use el nuevo src directamente.
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.setAttribute('src', thumb.getAttribute('data-full'));
          }
        });
      });

      updateCtaLink(variants[0]);
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-poa-pdp]');
      roots.forEach(function (root) {
        initPoaPdp(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prendas-pedido-productos"]) return;
  try {
    
  (function () {
    function initPoaCollNav(nav) {
      if (!nav || nav.dataset.poaCollnavInit) return;
      nav.dataset.poaCollnavInit = 'true';

      var track = nav.querySelector('.poa-collnav__track');
      var btnL = nav.querySelector('.poa-collnav__arrow--left');
      var btnR = nav.querySelector('.poa-collnav__arrow--right');
      if (!track || !btnL || !btnR) return;

      var step = 160;

      btnL.addEventListener('click', function () {
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });
      btnR.addEventListener('click', function () {
        track.scrollBy({ left: step, behavior: 'smooth' });
      });

      function updateArrows() {
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        btnL.style.opacity = atStart ? '0' : '1';
        btnL.style.pointerEvents = atStart ? 'none' : 'auto';
        btnR.style.opacity = atEnd ? '0' : '1';
        btnR.style.pointerEvents = atEnd ? 'none' : 'auto';
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    function initAll() {
      document.querySelectorAll('.poa-collnav').forEach(initPoaCollNav);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
